const css = `._2IFbnW__link{color:var(--base-text-secondary);text-decoration:underline}._2IFbnW__tagShimmer{max-width:40%;min-height:26px}._2IFbnW__truncatedContent{position:relative}._2IFbnW__truncatedContent:after{content:"";width:100%;height:30px;background:linear-gradient(to bottom,transparent,var(--base-backgrounds-default));pointer-events:none;position:absolute;bottom:0;left:0}._2IFbnW__content ul{margin:0;padding:0}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"content":"_2IFbnW__content","tagShimmer":"_2IFbnW__tagShimmer","truncatedContent":"_2IFbnW__truncatedContent","link":"_2IFbnW__link"};
